import { useEffect, useRef } from 'react'

export function useAnimation(callback: () => any, condition: any = true) {
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  useEffect(() => {
    if (condition) {
      const fn = () => {
        callbackRef.current()

        id = window.requestAnimationFrame(fn)
      }

      let id = window.requestAnimationFrame(fn)

      return () => window.cancelAnimationFrame(id)
    }
  }, [condition])
}
